import { Box, Typography } from "@mui/material";
import PortfolioTable from "../../components/common/PortfolioTable/PortfolioTable";

export default function PortfolioGrid({ searchText, tableRef, onSummaryChange, apiRef, myPortfolioOnly  }) {
    return (
        <Box
            sx={{
                display: "flex",
                gap: 3,
                alignItems: "center",
                bgcolor: "#fff",
                px: 2,
                py: 1.5,
            }}
        >
           
                <PortfolioTable
                    ref={tableRef}
                    apiRef={apiRef}
                    searchText={searchText}
                    onSummaryChange={onSummaryChange}
                    myPortfolioOnly={myPortfolioOnly}
                  />
            

        </Box>
    );
}
